module.exports = __webpack_public_path__ + "media/images/pcr_logo-34154bf8.png";